/**
 * Parses an integer that must be at least `minimum`.
 *
 * A missing or blank value returns `fallback`. A supplied value that is not an
 * integer, or is below `minimum`, throws.
 *
 * @example
 * parseIntAtLeast(undefined, 10, 2); // 10
 * parseIntAtLeast('16', 10, 2); // 16
 * parseIntAtLeast('0', 10, 1); // throws
 */
export function parseIntAtLeast(
  value: string | number | null | undefined,
  fallback: number,
  minimum: number,
  name?: string,
): number {
  if (value == null || (typeof value === 'string' && value.trim() === '')) {
    return fallback;
  }

  const parsed = typeof value === 'number' ? value : Number(value.trim());

  if (!Number.isInteger(parsed) || parsed < minimum) {
    const shown = typeof value === 'string' ? value.trim() : String(value);

    throw new Error(
      `${name ?? 'Value'} must be an integer of ${minimum} or more (got ${shown})`,
    );
  }

  return parsed;
}
